export const styles = {
  dropdownButton: {
    marginLeft: '21px',
  },
  folderSelection: {
    display: 'flex',
    marginLeft: '5px',
  },
  listGroup: {
    border: 'none',
  },
  listGroupItem: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    border: 'none',
    padding: '5px',
    borderTop: 'none',
  },
}
